// swup hook which updates the body classes and attributes
export const updateBodyClasses = (visit, { page }) => {
  if (!page.html) return;
  const doc = new DOMParser().parseFromString(page.html, "text/html");
  const newElBody = doc.querySelector("body");
  const elBody = document.body;

  // attach parsed document to visit for later use
  visit._parsedDocument = doc;

  // replace classes
  elBody.className = newElBody.className;
  // replace attributes
  const attributes = [
    "style",
    "data-theme",
    "data-header-tint",
    "data-reveal-template",
  ];
  const newAttrs = {};
  for (const attr of newElBody.attributes) {
    newAttrs[attr.name] = attr.value;
  }

  attributes.forEach((attr) => {
    if (attr in newAttrs) {
      document.body.setAttribute(attr, newAttrs[attr]);
    } else {
      document.body.removeAttribute(attr);
    }
  });
};
